<div class="page-head-section">
  <p>Achievements</p>
</div>
<div class="achievements-container">
  <div class="filters" style="margin-bottom: 30px">
    <div class="drop-area res-area">
      <p-dropdown
        placeholder="Filter by year"
        [options]="yearList"
        [(ngModel)]="typeFilter"
        (onChange)="filterByType($event)"
      ></p-dropdown>
    </div>

    <button (click)="ClearFilters()" class="clear-filter">Clear Filters</button>
  </div>

  <div *ngIf="players.length === 0" class="noData">No Data found !</div>

  <div class="ui-g" *ngIf="players.length > 0">
    <div *ngFor="let data of players" class="ui-g-3 ui-lg-3 ui-md-4 ui-sm-12">
      <div class="achieve-card">
        <div class="achieve-medal">
          <img
            *ngIf="data.medal === 'Silver'"
            src="assets/icons/silver-medal.png"
            alt=""
          />
          <img
            *ngIf="data.medal === 'Gold'"
            src="assets/icons/gold-medal.png"
            alt=""
          />
          <img
            *ngIf="data.medal === 'Bronze'"
            src="assets/icons/bronze-medal.png"
            alt=""
          />
        </div>
        <div class="achieve-content">
          <h1>{{ data?.name }}</h1>
          <p><span class="sub-h">Medal:</span>  <span style="font-family: Bold; font-size:18px"> {{ data?.medal }}</span> </p>
          <h2><span class="sub-h">Event:</span> {{ data?.event }}</h2>
          <h3><span class="sub-h">Location:</span> {{ data?.location }}</h3>
          <h4><span class="sub-h">Category:</span> {{ data?.comments }}</h4>
        </div>
      </div>
    </div>
  </div>
</div>
